import { UAT_STORAGE_KEY } from '../constants'
import { User } from '../types'
import { isBrowser } from './common'

export const storeUserAccessToken = (accessToken: string): boolean => {
  if (!isBrowser()) {
    return false
  }
  try {
    window.localStorage.setItem(UAT_STORAGE_KEY, accessToken)
    return true
  } catch (error) {
    return false
  }
}

export const getUserAccessToken = (): string | null => {
  if (!isBrowser()) {
    return null
  }
  return window.localStorage.getItem(UAT_STORAGE_KEY)
}

export const removeUserAccessToken = (): boolean => {
  if (!isBrowser()) {
    return false
  }
  try {
    window.localStorage.removeItem(UAT_STORAGE_KEY)
    return true
  } catch (error) {
    return false
  }
}

export const isUserLoggedIn = (): boolean => {
  return !!getUserAccessToken()
}

export const isFlagEnabled = (flag: string, user?: User): boolean => {
  if (!user) {
    return false
  }
  return user.flags.indexOf(flag) !== -1
}

export const isFeatureEnabled = (feature: string, user?: User): boolean => {
  if (!user) {
    return false
  }
  return user.features.indexOf(feature) !== -1
}
